import React from 'react';
import { NewRequestButtonProps } from '../types';
import { useTranslation } from '../context/TranslationContext';
import '../styles/NewRequestButton.css';

const NewRequestButton: React.FC<NewRequestButtonProps> = ({ onClick }) => {
  const { t } = useTranslation();
  return (
    <button className="new-request-button" onClick={onClick}>
      <svg className="plus-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 5V19M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
      <span>{t('common.new_request')}</span>
    </button>
  );
};

export default NewRequestButton; 